import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
// --- Import redux
import { connect } from "react-redux";

function PrivateRoute({ children, isAuth, ...rest }) {
  return isAuth ? (
    <Route {...rest} render={() => children} />
  ) : (
    <Route
      {...rest}
      render={({ location }) => {
        return (
          <Redirect
            to={{
              pathname: "/login",
              search: location.search,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
}

PrivateRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isAuth: PropTypes.bool.isRequired,
};

const mapDispatchToProps = {};

const mapStateToProps = (state) => {
  return {
    isAuth: state.userDataStore.isAuth,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
